var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClient(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M21.02 0c.792.135 1.594.23 2.375.396 5.813 1.302 10.396 6.156 11.386 12.031 1.073 6.458-1.938 12.625-7.646 15.792-.719.396-1.396.541-2.198.541-3.614-.02-7.24-.01-10.854-.02-.23 0-.469-.105-.667-.22-.718-.426-1.448-.832-2.114-1.322C7.604 24.49 5.5 20.844 5.072 16.26 4.397 8.958 9.26 2.167 16.386.437 17.187.24 18.02.147 18.833 0h2.188Zm-2.27 8.792c-.792.333-1.51.635-2.25.948a33.1 33.1 0 0 0-.854-.855c-.573-.562-1.334-.583-1.844-.062-.5.51-.48 1.26.073 1.812.302.303.625.584.875.823-.344.813-.646 1.542-.959 2.292h-1.208c-.77.01-1.323.52-1.333 1.24-.01.729.552 1.26 1.343 1.26h1.198c.334.781.636 1.5.948 2.26-.26.26-.552.542-.844.844-.562.573-.593 1.323-.072 1.844.52.52 1.27.49 1.843-.083.302-.302.584-.625.802-.855l2.292.959v1.198c.01.791.542 1.354 1.26 1.343.709-.01 1.23-.562 1.23-1.333V21.22c.77-.323 1.49-.625 2.291-.959.23.25.51.563.802.855.573.573 1.323.604 1.844.093.521-.51.5-1.27-.073-1.843-.302-.302-.635-.573-.875-.782.354-.843.646-1.562.969-2.312h1.23c.76-.01 1.312-.542 1.312-1.26 0-.709-.563-1.23-1.323-1.24h-1.219c-.323-.781-.625-1.5-.948-2.271.27-.26.573-.542.865-.844.541-.562.573-1.302.073-1.812-.51-.521-1.271-.5-1.844.052-.302.302-.584.614-.823.864-.813-.333-1.52-.635-2.281-.947v-1.22c-.01-.76-.542-1.322-1.25-1.322-.709 0-1.24.552-1.25 1.312v1.209Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M19.375 40c-.677-.25-1.385-.437-2.01-.781-1.135-.636-1.823-1.656-2.198-2.948h9.646a4.695 4.695 0 0 1-1.208 2.177 4.884 4.884 0 0 1-2.813 1.48c-.063.01-.115.04-.177.072h-1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M0 14.687c.302-.708.844-1.01 1.615-.937.312.031.625-.01.937.01a1.25 1.25 0 0 1 0 2.5c-.437.021-.885.01-1.323 0-.625-.02-.979-.416-1.219-.937-.01-.219-.01-.427-.01-.636Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M40 15.312c-.302.709-.844 1.01-1.615.938-.312-.031-.625.01-.937-.01a1.25 1.25 0 0 1-1.198-1.25c0-.667.52-1.22 1.198-1.24.437-.021.885-.01 1.323 0 .635.01.969.416 1.219.937.01.209.01.417.01.625Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M20 31.25h6.094c.833 0 1.396.5 1.406 1.24 0 .74-.562 1.26-1.385 1.26h-12.23c-.822 0-1.395-.52-1.385-1.26.01-.74.573-1.24 1.406-1.24H20Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M34.99 27.5c-.615 0-2.011-1.052-2.188-1.646-.146-.51.02-1.031.448-1.354.395-.292.968-.344 1.395-.052.407.27.813.573 1.188.885.406.344.52.896.323 1.386a1.24 1.24 0 0 1-1.167.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M6.01 5.73c-.603 0-2-1.022-2.176-1.605A1.26 1.26 0 0 1 4.26 2.76c.416-.322.979-.364 1.427-.062.396.27.781.562 1.146.865.416.354.52.895.333 1.385a1.247 1.247 0 0 1-1.156.781Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M5.885 24.291c.625 0 1.073.303 1.26.782.188.468.084 1.02-.302 1.354-.385.333-.791.635-1.208.906-.52.334-1.187.188-1.583-.281-.396-.469-.417-1.177.031-1.594.417-.396.917-.729 1.396-1.052.125-.104.333-.104.406-.114Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M34.094 5.729c-.604.01-1.062-.292-1.26-.76-.209-.49-.105-1.032.312-1.386.375-.323.771-.625 1.177-.896.51-.333 1.198-.208 1.594.25.385.459.427 1.188 0 1.605-.427.406-.938.74-1.427 1.072-.125.094-.313.094-.396.115Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M23.75 15c0 2.062-1.677 3.75-3.74 3.75-2.062 0-3.75-1.688-3.75-3.74 0-2.062 1.678-3.75 3.74-3.75A3.739 3.739 0 0 1 23.75 15Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 35.502,
    x2: 32.898,
    y1: 24.781,
    y2: 26.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 28.581,
    x2: 5.707,
    y1: 4.67,
    y2: 22.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 2.948,
    x2: 0.868,
    y1: 14.151,
    y2: 16.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 39.198,
    x2: 37.128,
    y1: 14.147,
    y2: 16.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 24.291,
    x2: 23.402,
    y1: 31.656,
    y2: 35.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 22.749,
    x2: 20.217,
    y1: 36.877,
    y2: 41.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 6.512,
    x2: 3.919,
    y1: 3.019,
    y2: 5.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 6.491,
    x2: 3.905,
    y1: 24.815,
    y2: 26.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 35.475,
    x2: 32.883,
    y1: 3.024,
    y2: 5.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 22.148,
    x2: 16.261,
    y1: 12.476,
    y2: 16.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClient);
export default __webpack_public_path__ + "static/media/Client.d3cecf8fe0d6e16ffff529173d0faea8.svg";
export { ForwardRef as ReactComponent };